import React from 'react';
import Loader from '../../loader/Loader';
import cx from './gradientbutton.module.scss';
export default function GradientButton({ children, disabled, loading, onClick }: { onClick: any; children?: React.ReactNode, disabled?: boolean, loading?: boolean }) {
    return (
        <button className={cx.gradientButton} disabled={disabled || loading} onClick={onClick} type='button'>
            {loading ? <Loader color='#fff' size='20px'/> : children}
        </button>
    )
}
